import Storage from "@iap/kit-storage";
import LogUtil from "@/betby/utils/LogUtil";

const AUTH_TOKEN_KEY = "Admin-Token";

export function syncAdminToken(accessToken: string | null): void {
  if (typeof window === "undefined") {
    return;
  }

  if (accessToken) {
    Storage.setStorage(AUTH_TOKEN_KEY, `Bearer ${accessToken}`);
    LogUtil.debug("[AuthTokenStorage] Token 已同步到 Storage (Admin-Token)");
    return;
  }

  Storage.removeStorage(AUTH_TOKEN_KEY);
  LogUtil.debug("[AuthTokenStorage] Token 已从 Storage 清除 (Admin-Token)");
}
